import { Col, Row, Typography } from "antd";
import { INSTA_ICON } from "assets";
import { YOUTUBE_ICON } from "assets";
import { LINKEDIN_ICON } from "assets";
import { FB_ICON } from "assets";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";

const PageFooter = () => {
  return (
    <footer className="page-footer">
      <div className="page-footer-inner container">
        <Row gutter={[20, 20]}>
          <Col xs={16} md={14} className="company-title">
            <Typography.Title className="m-0 company-title-text" level={5}>
              HENNIE STANDER – TECHNICAL AND BUSINESS DEVELOPMENT CONSULTANTS
              (PTY) Ltd
            </Typography.Title>
          </Col>
          <Col xs={8} md={4} className="quick-links">
            <Typography.Title className="m-0" level={5}>
              Quick Actions
            </Typography.Title>
            <div className="quick-links-inner">
              <NavLink className={"font-roboto"}>About Us</NavLink>
              <NavLink className={"font-roboto"}>What We Offer</NavLink>
              <NavLink className={"font-roboto"}>Contact Us</NavLink>
            </div>
          </Col>
          <Col xs={24} md={4} className="social-media">
            <Typography.Title className="m-0" level={5}>
              Follow us on Socials
            </Typography.Title>
            <div className="social-media-inner">
              <ReactSVG src={FB_ICON} />
              <ReactSVG src={INSTA_ICON} />
              <ReactSVG src={LINKEDIN_ICON} />
              <ReactSVG src={YOUTUBE_ICON} />
            </div>
          </Col>
        </Row>
        <div className="footer-bottom-part">
          <Typography.Paragraph className="m-0">
            © 2023, HENNIE STANDER – TECHNICAL AND BUSINESS DEVELOPMENT
            CONSULTANTS (PTY) Ltd. All rights reserved
          </Typography.Paragraph>
          <Typography.Paragraph className="m-0">
            Terms and Condition . Privacy Policy
          </Typography.Paragraph>
        </div>
      </div>
    </footer>
  );
};

export default PageFooter;
